import styled, { css } from 'styled-components';
import { ButtonBase as Button, Icon } from '@deerplusofficial/pos-components';
import { color } from '@deerplusofficial/pos-helper';

export const Cell = styled(Button)`
  width: ${props => (props.full ? '100%' : '50%')};
  & + & {
    border-left: 1px solid ${color.border};
  }
`;

export const CellInner = styled.div`
  display: flex;
  ${props =>
    props.full
      ? css`
          padding: 0 25px;
        `
      : css`
          justify-content: center;
        `};
  align-items: center;
  height: 46px;
  color: ${color.text.title};
`;

export const CellIcon = styled(Icon)`
  font-size: 20px;
  ${props =>
    props.suffix &&
    css`
      margin-right: 8px;
    `}
  ${props =>
    props.prefix &&
    css`
      margin-left: 8px;
    `}
`;



// WEBPACK FOOTER //
// ./src/components/Cart/CartToolBarCell.js